var Vue = require('vue')
var Vuex = require('vuex')

Vue.use(Vuex)

var local = require('./local')

var state = {
  logged: local.get('client.logged'),
  user: local.get('client.user'),
  auth: local.get('client.auth'),
  active: local.get('client.active'),
  language: local.get('client.language')
}

var mutations = {
  LOGIN: function (state, auth, user) {
    state.logged = { value: true }
    state.auth = auth
    state.user = user
  },
  SET_USER: function (state, user) {
    state.user = user
  },
  ACTIVATE: function (state) {
    state.active = { value: true }
  },
  DEACTIVATE: function (state) {
    state.active = { value: false }
  },
  CLEAR: function (state) {
    state.logged = null
    state.user = null
    state.auth = null
    state.actve = null
  },
  SET_LANGUAGE: function (state, lang) {
    state.language = lang
  }
}

module.exports = new Vuex.Store({
  state: state,
  mutations: mutations
})



// WEBPACK FOOTER //
// ./src/common/store/index.js